import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import sharedMutations from 'vuex-shared-mutations';
import Cookies from 'js-cookie';
Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [
        createPersistedState({
            storage: {
                getItem: key => Cookies.get(key),
                setItem: (key, value) => Cookies.set(key, value, {
                    secure: false
                }),
                removeItem: key => Cookies.remove(key)
            }
        }),
        sharedMutations({
            predicate: ['setToken', 'setUser', 'setLogTime', 'setSnackBar']
        })
    ],
    state: {
        token: null,
        logTime: null,
        user: null,
        isUserLoggedIn: false,
        snackbar: {
            showing: false,
            color: 'success'
        }
    },
    mutations: {
        setToken(state, token) {
            state.token = token
            state.isUserLoggedIn = !!(token)
        },
        setUser(state, user) {
            state.user = user
        },
        setLogTime(state, logTime) {
            state.logTime = logTime
        },
        setSnackBar(state, snackbar) {
            state.snackbar = snackbar
        }
    },
    actions: {
        setToken({
            commit
        }, token) {
            commit('setToken', token)
        },
        setUser({
            commit
        }, user) {
            commit('setUser', user)
        },
        setLogTime({
            commit
        }, logTime) {
            commit('setLogTime', logTime)
        },
        setSnackbar({
            commit
        }, snackbar) {
            if (typeof snackbar.showing == "undefined") {
                snackbar.showing = true;
            }
            snackbar.text = snackbar.text || 'Operação efectuada com sucesso.';
            snackbar.color = snackbar.color || 'success';
            commit('setSnackBar', snackbar);
        }
    }
})